import { accessToken } from "./supabase";

// Thin wrapper around the server API. Attaches the Supabase bearer token so the
// server can resolve identity and enforce authorization (mirrored RLS).
export async function api<T = any>(
  path: string,
  opts: { method?: string; body?: unknown; query?: Record<string, string> } = {}
): Promise<T> {
  const token = await accessToken();
  const url = new URL(path, window.location.origin);
  if (opts.query) for (const [k, v] of Object.entries(opts.query)) url.searchParams.set(k, v);

  const res = await fetch(url.toString(), {
    method: opts.method ?? (opts.body ? "POST" : "GET"),
    headers: {
      "content-type": "application/json",
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data as any)?.error ?? `request failed (${res.status})`);
  return data as T;
}

// Multipart upload (voice check-in audio). Returns { transcript }.
export async function uploadAudio(blob: Blob): Promise<{ transcript: string }> {
  const token = await accessToken();
  const form = new FormData();
  form.append("audio", blob, "checkin.webm");
  const res = await fetch("/api/checkin/transcribe", {
    method: "POST",
    headers: token ? { authorization: `Bearer ${token}` } : {},
    body: form,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data as any)?.error ?? "transcription failed");
  return data as { transcript: string };
}
